import { Box, VStack, Avatar, Input } from '@chakra-ui/react';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import FormikFormControl from 'components/common/forms/FormikFormControl';

/**
 * AvatarProfile - Component for displaying user avatar
 * Manages the avatar image display, gamer tag input
 * @param {string} avatarDataUri - The data URI for the generated avatar image
 */
function AvatarProfile({ avatarDataUri }) {
  return (
    <Box
      id="avatar-container"
      boxShadow="md"
      borderRadius="2xl"
      maxW={{ base: '100%', lg: '400px' }}
      p={5}
    >
      <VStack spacing={4}>
        {/* Avatar Image Display */}
        <Avatar
          src={avatarDataUri}
          alt="User Avatar"
          size="full"
          boxSize={{ base: '250px', md: '380px' }}
        />

        {/* Gamer Tag Input Field */}
        <Field flex={1} name="gamerTag">
          {({ field, form }) => (
            <FormikFormControl
              label="GamerTag"
              helperText="Enter your desired gamer tag. This will represent you on leaderboards and achivements within the platform."
              errors={form.errors.gamerTag}
              touched={form.touched.gamerTag}
            >
              <Input {...field} />
            </FormikFormControl>
          )}
        </Field>
      </VStack>
    </Box>
  );
}

AvatarProfile.propTypes = {
  avatarDataUri: PropTypes.string.isRequired,
};

export default AvatarProfile;
